export default {
    cartItems: (state) => state.items,
    cartTotalPrice: (state) => state.totalPrice,
    cartTotalQuantity: (state) => state.totalQuantity,
};